import { render, staticRenderFns } from "./CRLinkS.vue?vue&type=template&id=13d3d116&"
import script from "./CRLinkS.vue?vue&type=script&lang=js&"
export * from "./CRLinkS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports